module.exports = __webpack_public_path__ + "static/chooseRomance-fa9059122c5606541dac3ff92f2a0a05.jpg";